export const languageKey = 'topspeed-calculator-language-key';
export const languageHeaderKey = 'x-language';
export const ReturnUrlPrefix = '?returnUrl=';
export const apiUrl = process.env.NODE_ENV === `development` ? 'https://localhost:44328' : ''; //will be served from same domain!
